module.exports = __webpack_public_path__ + "static/img/应用案例.592bdc0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/产品及服务/DNA提取+PCR扩增+测序/应用案例.png
// module id = x+M/
// module chunks = 16